import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App';

// Import futuristic fonts for auth pages
import '@fontsource/orbitron';
import '@fontsource/exo-2';

if (process.env.NODE_ENV === 'development') {
  import('react-grab');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
